import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({

  navItemsStyle: {
    //color: "#354052", 
    textDecoration: "none",
    ":hover" : {
        background: "#354052",
        color: "#fff",
        transition: ".2s"
    }
  },
  navLinkStyle: {
    backgroundColor: "#354052", 
    borderBottom: "0px",
    textDecoration: "none",
    transition: "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out",
    ":hover" : {
        background: "#354052",
        color: "#fff",
        transition: ".2s"
    }
  },
  buttonStyle: {
    cursor: "pointer",
    width: "100%",
    textAlign: "left",
    backgroundColor: "#354052",
    color: "#adb5bd",
    border: "0px",
    ":hover" : {
      background: "#354052",
      color: "#fff",
      transition: ".2s"
  },
  }

  
//   .collapse.show, 
//   .collapsing {
//     background: #313b4c;
//   }

  
//   .nav-item.open {
//     color: #e9ecef;
//     background: #313b4c;
//   }
  
//   .nav-item.active {
//     color: #e9ecef;
//     background: #2d3646 !important;
//   }
  
//   .nav-item:hover {
//     background: #313b4c;
//     color: #fff;
//     transition: .2s;
//   }

  
  
       
  });

  export default styles;